import React from 'react'
import styled from 'styled-components'

import { Div } from 'elements/layout/Div'
import { Li } from 'elements/layout/Li'
import { Ul } from 'elements/layout/Ul'
import { Link } from 'elements/text/Link'
import { P } from 'elements/text/P'

import { Sidebar } from 'general/structure/Sidebar'

const StyledLi = styled(Li)`
  display: block;
  margin: 0 0 25px 0;
  padding: 2px 10px 2px 0;
  text-align: right;
  &:hover {
    border-right: grey 1px solid;
    padding: 2px 9px 2px 0;
  }
`

export type TGuideMenuDesktopProps = {
  titles: { id: string; textContent: string }[]
}

export const GuideMenuDesktop: TFC<TGuideMenuDesktopProps> = ({ titles }) => (
  <Sidebar w="initial">
    <Div maxW="250px" m="0 0 0 auto" p="1em 0 0 1em">
      <Ul>
        {titles.map((title) => (
          <StyledLi key={title.id}>
            <Link to={`#${title.id}`} color="black30" hoverColor="black70">
              <P>{title.textContent}</P>
            </Link>
          </StyledLi>
        ))}
      </Ul>
    </Div>
  </Sidebar>
)
